// 智能搜索高级查询  包含关系

// 查询类型
export const searchOptions = [
  { value: 'simple', label: '简单查询' },
  { value: 'complex', label: '高级查询' },
  { value: 'tree', label: '条件树查询' },
  { value: 'someThing', label: '事件查询' },
  { value: 'accurate', label: '精确查询' }
];
export const searchOptionsObj = {
  simple: '简单查询',
  complex: '高级查询',
  tree: '条件树查询',
  someThing: '事件查询',
  accurate: '精确查询'
};

export const opRelations = [
  // { value: 0, label: '首次诊断' },
  // { value: 1, label: '末次诊断' },
  { value: 2, label: '包含' },
  { value: 3, label: '未包含' },
  { value: 4, label: '等于' },
  { value: 5, label: '不等于' },
  { value: 6, label: '大于' },
  { value: 7, label: '小于' },
  { value: 8, label: '阈值范围' }
];
export const opRelationsObj = {
  // 0: '首次诊断',
  // 1: '末次诊断',
  2: '包含',
  3: '未包含',
  4: '等于',
  5: '不等于',
  6: '大于',
  7: '小于',
  8: '阈值范围'
}


//  关系二  去掉阈值
export const opRelations2 = [
  { value: 0, label: '首次诊断' },
  { value: 1, label: '末次诊断' },
  { value: 2, label: '包含' },
  { value: 3, label: '未包含' },
  { value: 4, label: '等于' },
  { value: 5, label: '不等于' },
  { value: 6, label: '大于' },
  { value: 7, label: '小于' }
];

// 只能搜索高级查询   与  或
export const opAndOr = [
  { value: 0, label: '并且' },
  { value: 1, label: '或者' }
];
export const opAndOrObj ={
  0: '并且',
  1: '或者'
}

// 测试数据
export const options = [
  { value: 0, label: '小病' },
  { value: 1, label: '或者' }
];

// 时间条件
export const optionsTime = [
  { value: 0, label: '无' },
  { value: 1, label: '之前' },
  { value: 2, label: '之后' },
  { value: 3, label: '等于' }
];

// 树节点 首次末次
export const treeOptions = [
  { value: 0, label: '首次' },
  { value: 1, label: '末次' }
];
// 树节点 对照数据
export const treeOptions2 = {
  0: '首次',
  1: '末次'
};
